/**
 * Format milliseconds to HH:MM:SS.cs (centiseconds)
 */
export function formatTime(ms: number): string {
  const isNegative = ms < 0;
  const absMs = Math.abs(ms);

  const centiseconds = Math.floor((absMs % 1000) / 10);
  const seconds = Math.floor((absMs / 1000) % 60);
  const minutes = Math.floor((absMs / (1000 * 60)) % 60);
  const hours = Math.floor(absMs / (1000 * 60 * 60));

  const pad = (n: number, digits: number = 2) => n.toString().padStart(digits, '0');

  const prefix = isNegative ? '-' : '';

  if (hours > 0) {
    return `${prefix}${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${pad(centiseconds)}`;
  }
  return `${prefix}${pad(minutes)}:${pad(seconds)}.${pad(centiseconds)}`;
}

/**
 * Format milliseconds to a human-readable duration (e.g., "2h 15m 30s")
 */
export function formatDuration(ms: number): string {
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const hours = Math.floor(ms / (1000 * 60 * 60));

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(' ');
}
